/**
 * Get the creative name from the pathname:
 * - If the pathname contains '/s/', return 'Search'.
 * - If the pathname contains '/b/', return the last segment of the pathname.
 * - If the pathname contains '/p/', return 'Product'.
 * - If the pathname is '/', return 'Home'.
 * - If the pathname is not '/', return the last segment of the pathname.
 */
export const getCreativeNameFromPathname = (pathname: string) => {
	const segments = pathname.split('/');

	if (pathname.includes('/s/')) {
		return 'Search';
	}

	if (pathname.includes('/b/')) {
		const lastSegment = segments[segments.length - 1];
		return lastSegment;
	}

	if (pathname.includes('/p/')) {
		return 'Product';
	}

	if (pathname === '/') {
		return 'Home';
	}

	if (!segments.length) {
		return pathname;
	}

	return segments[segments.length - 1];
};

/**
 * Get the promotion name from the gtm class element:
 * - If data-override is present on the element, use it.
 * - If the element contains an image, fall back to the image's alt attribute.
 * - Otherwise, fall back to the element's text content.
 */
export const getPromotionNameFromGtmClassElement = (element: Element) => {
	if (!element || !(element instanceof HTMLElement)) {
		return;
	}

	const dataOverride = element.dataset.override?.trim();

	if (dataOverride) {
		return dataOverride;
	}

	const imageElement = element.querySelector('img');

	if (imageElement instanceof HTMLImageElement) {
		const promotionName = imageElement.alt?.trim();

		return promotionName ? promotionName : undefined;
	}

	let promotionName = element.textContent ? element.textContent : undefined;
	promotionName = promotionName?.replace('chevron_right', '').trim();

	return promotionName ? promotionName : undefined;
};
